import { render, staticRenderFns } from "./Ocpendiente.vue?vue&type=template&id=dfd2610c&scoped=true"
import script from "./Ocpendiente.vue?vue&type=script&lang=js"
export * from "./Ocpendiente.vue?vue&type=script&lang=js"
import style0 from "./Ocpendiente.vue?vue&type=style&index=0&id=dfd2610c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd2610c",
  null
  
)

export default component.exports